import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import { VisualCrossingResponseType } from '@/utilities/weather/services/visualCrossing/types/VisualCrossingResponseType'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'

export default class VisualCrossingApi extends AbstractWeatherService {
  private readonly apiUrl: string = 'https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline'

  async getInfo({ lat, lng }: CoordinateType, date: Dayjs): Promise<WeatherType> {
    const params = new URLSearchParams({
      key: this.apiKey,
      unitGroup: 'metric',
    })

    const { data } = await this.httpClient.get<VisualCrossingResponseType>(
      `${this.apiUrl}/${lat},${lng}/${date.format('YYYY-MM-DD')}?${params.toString()}`,
    )

    const weather = data?.days?.at(0) as VisualCrossingResponseType['days'][0] | undefined

    if (!weather) {
      throw new Error('Invalid response')
    }

    return {
      title: weather.conditions,
      description: weather.conditions,
      icon: `${weather.icon}.png`,
      temp: weather.temp,
    }
  }
}
